export default __webpack_public_path__ + "static/media/676.55d7194a.png";